import axios from 'axios'
import { marketConfig, userApiConfig, userConfig, webConfig } from '@base/configs'

export const authUser = axios.create({
  method: 'post',
  baseURL: `${userConfig.baseURL}/token/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const resetPassword = axios.create({
  method: 'post',
  baseURL: `${webConfig.baseURL}/password/reset/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const resetPasswordConfirm = axios.create({
  method: 'post',
  baseURL: `${webConfig.baseURL}/password/reset/confirm/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const emailConfirm = axios.create({
  method: 'post',
  baseURL: `${webConfig.baseURL}/email/confirm/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const getResetPasswordData = axios.create({
  method: 'post',
  baseURL: `${userConfig.baseURL}/get_reset_password_data/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const getEmailConfirmationData = axios.create({
  method: 'post',
  baseURL: `${userConfig.baseURL}/get_email_confirmation_data/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const sendFeedback = axios.create({
  method: 'post',
  baseURL: `${userConfig.baseURL}/send_feedback/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const createUser = axios.create({
  method: 'post',
  baseURL: `${userConfig.baseURL}/register_user/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

// Market

export const createMarket = axios.create({
  method: 'post',
  baseURL: `${userConfig.baseURL}/register_market/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const createSoloMarket = axios.create({
  method: 'post',
  baseURL: `${userConfig.baseURL}/register_solo_market/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const getAnonMarket = axios.create({
  method: 'get',
  baseURL: `${marketConfig.baseURL}/market/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

// Online Booking

export const getShelfTypeServices = axios.create({
  method: 'get',
  baseURL: `${marketConfig.baseURL}/shelf_type_services/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getShelfTypes = axios.create({
  method: 'get',
  baseURL: `${marketConfig.baseURL}/shelf_types/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getShelfPeriodPrices = axios.create({
  method: 'get',
  baseURL: `${marketConfig.baseURL}/shelf_period_prices/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getShelfTypeAvailability = axios.create({
  method: 'get',
  baseURL: `${marketConfig.baseURL}/shelf_type_availability/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const bookingRequest = axios.create({
  method: 'post',
  baseURL: `${marketConfig.baseURL}/booking_request/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getBookingRequest = axios.create({
  method: 'get',
  baseURL: `${marketConfig.baseURL}/booking_requests/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const bookingPaymentTransaction = axios.create({
  method: 'delete',
  baseURL: `${marketConfig.baseURL}/booking_payment_transaction/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

// Authenticated payment for an existing customer who logs in inside the embed iframe.
export const customerInitPayment = axios.create({
  method: 'post',
  baseURL: `${userApiConfig.baseURL}/booking_request/init_payment/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const customerConfirmPayment = axios.create({
  method: 'post',
  baseURL: `${userApiConfig.baseURL}/booking_request/confirm_payment/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const customerBookingPaymentTransaction = axios.create({
  method: 'delete',
  baseURL: `${userApiConfig.baseURL}/booking_payment_transaction/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})